import { Button, Checkbox, Col, Descriptions, Drawer, Form, Radio, Row, Select, Space, Spin, Table, Tabs, Typography } from 'antd'
import React, { Component } from 'react'
import { PmsAPI } from '../../../controller/PmsAPI'
import moment from 'moment'
import ResponsiveECharts from '../../components/ResponsiveECharts'
import PmsRoomSelect from '../../components/PmsRoomSelect'
import DateWithWeekday from '../../components/DateWithWeekday'


export class SalesPage extends Component {
    state = {
        loading: false,
        detailLoading: false,
        dateType: 'cidate',
        periodType: 'month',
        selectedRoomCod: null,
        salesChartOption: null,
        detailDate: null,
        details: [],
        showOnlyBelowPrice: false,
        orderDateStatDrawerVisible: false,
        orderDateAnalysisChartOption: null,
        orderDateAnalysisAvg: 0,
        orderDateAnalysisTotal: 0,
        orderSourceStatDrawer: {
            open: false,
            details: [],
        },
        overviewData: [],
        activeTabKey: '1',
        // 快取過濾選項
        roomCodFilters: [],
        useCodFilters: [],
    }
    table = React.createRef();

    componentDidMount() {
        this.refresh();
    }
    refresh = () => {
        this.updateSalesChartOption();

    }
    updateSalesChartOption = async () => {
        let result = null;
        this.setState({ loading: true });
        await PmsAPI.sale[this.state.dateType].stat(this.state.periodType, this.state.selectedRoomCod).then((response) => {
            result = response.data;
            console.log(result);
        }).finally(() => {
            this.setState({ loading: false });
        });
        // Store overview data for the table
        this.setState({ overviewData: result.items });
        
        const option = {
            tooltip: {
                trigger: 'axis',
                axisPointer: {
                    type: 'cross',
                    crossStyle: {
                        color: '#999'
                    }
                }
            },
            grid: {
                bottom: '110'
            },
            dataZoom: [
                {
                    show: true,
                    bottom: 20,
                    type: 'slider',
                    start: this.state.dateType === 'insdate' ? 60 : 35,
                    end: this.state.dateType === 'insdate' ? 100 : 100,
                }
            ],
            legend: {
                data: ['銷售總額', '取消總額', '銷售平均', '取消平均'],
                selected: {
                    '取消總額': false,
                    '取消平均': false
                }
            },
            xAxis: [
                {
                    type: 'category',
                    data: result.items.map((item) => item.dat),
                    axisPointer: {
                        type: 'shadow'
                    },
                    axisLabel: {
                        formatter: (value, index) => {
                            const [year, month, day] = value.split('/');
                            if (year && month && day)
                                return `${year % 2000}\n{bold|${month}}\n{bold|${day}}\n` + moment(value).format('dd');
                            if (year && month)
                                return `${year}\n{bold|${month}}`;
                            return `${year}`;
                        },
                        rich: {
                            bold: {
                                fontWeight: 700
                            }
                        }
                    }

                }
            ],
            yAxis: [
                {
                    type: 'value',
                    name: '金額',
                    min: 0,
                    axisLabel: {
                        formatter: 'NT$ {value}'
                    }
                },
                {
                    type: 'value',
                    name: '金額',
                    min: 0,
                    axisLabel: {
                        formatter: 'NT$ {value}'
                    }
                },
            ],
            series: [
                {
                    name: '銷售總額',
                    type: 'bar',
                    stack: 'totalSale',
                    tooltip: {
                        valueFormatter: function (value) {
                            return 'NT$ ' + Number(value).toLocaleString();
                        }
                    },
                    data: result.items.map((item) => item.sale_tot)
                },
                {
                    name: '取消總額',
                    type: 'bar',
                    stack: 'totalSale',
                    tooltip: {
                        valueFormatter: function (value) {
                            return 'NT$ ' + Number(value).toLocaleString();
                        }
                    },
                    data: result.items.map((item) => item.cancel_tot)
                },
                {
                    yAxisIndex: 1,
                    name: '銷售平均',
                    type: 'line',
                    tooltip: {
                        valueFormatter: function (value) {
                            return 'NT$ ' + Number(value).toLocaleString();
                        }
                    },
                    data: result.items.map((item) => Math.round(item.sale_tot / item.sale_qty))
                },
                {
                    yAxisIndex: 1,
                    name: '取消平均',
                    type: 'line',
                    tooltip: {
                        valueFormatter: function (value) {
                            return 'NT$ ' + Number(value).toLocaleString();
                        }
                    },
                    data: result.items.map((item) => Math.round(item.cancel_tot / item.cancel_qty))
                },
            ]
        }
        this.setState({ salesChartOption: option });
    }
    handleClickChartEvent = (e) => {
        const date = e.name;
        this.fetchDetail(date);
        // Switch to detail tab when chart is clicked
        this.setState({ activeTabKey: '2' });
        if (e.seriesIndex === 0) {
            this.setState({ filterType: 'not-canceled' });
        } else {
            this.setState({ filterType: 'canceled' });
        }
        console.log("click", e)
    }
    fetchDetail = (date) => {
        this.setState({ detailLoading: true, detailDate: date });
        return PmsAPI.sale[this.state.dateType].index(this.state.periodType, date, this.state.selectedRoomCod).then((response) => {
            const result = response.data;
            console.log(result);
            const details = result.items.map((item) => ({ ...item, id: `${item.ikey}-${item.ikey_seq_nos}`, order_offset_day: moment(item.ins_dat).diff(item.ci_dat, 'day') }));
            this.setState({ details: details }, () => {
                // 更新過濾選項快取
                this.updateFilterOptions();
            });
        }).finally(() => {
            this.setState({ detailLoading: false });
        });
    }
    
    // 更新過濾選項快取
    updateFilterOptions = () => {
        const roomCodFilters = [...new Set(this.state.details.map(item => item.room_cod).filter(Boolean))].map(value => ({
            text: value,
            value: value,
        }));
        
        const useCodFilters = [...new Set(this.state.details.map(item => item.use_cod).filter(Boolean))].map(value => ({
            text: value,
            value: value,
        }));
        
        this.setState({
            roomCodFilters,
            useCodFilters,
        });
    }
    updateOrderDateAnalysisChartOption = () => {
        const analysisDetails = this.getDetails().filter((item) => moment(item.ci_dat).diff(moment(), 'days') < 0);
        const totalSales = analysisDetails.length;
        const totalDaysBefore = analysisDetails.reduce((pv, cv, idx, arr) => pv + parseInt(cv.order_offset_day), 0)
        const chartDetails = analysisDetails.reduce((pv, cv, idx, arr) => {
            const date = moment(cv.ins_dat).format("YYYY-MM-DD");
            const d = pv.find((item) => item.order_offset_day === cv.order_offset_day);
            if (d) {
                d.count++;
                if (cv.cancel_dat !== null) {
                    d.cancel_count++;

                }
            } else {
                pv.push({
                    ins_dat: date,
                    order_offset_day: cv.order_offset_day,
                    count: 1,
                    cancel_count: cv.cancel_dat !== null
                });
            }
            return pv;
        }, []).sort((a, b) => a.order_offset_day - b.order_offset_day);
        const option = {
            dataset: {
                source: chartDetails,
            },
            legend: {},
            dataZoom: {},
            tooltip: {
                trigger: 'axis',
                axisPointer: {
                    type: 'cross',
                    crossStyle: {
                        color: '#999'
                    }
                }
            },
            xAxis: [
                {
                    type: 'category',
                    axisPointer: {
                        type: 'shadow'
                    },
                    // axisLabel: {
                    //     formatter: (value, index) => {
                    //         let today = false;
                    //         if (moment().format("YYYY-MM-DD") === moment(value).format("YYYY-MM-DD")) {
                    //             today = true;
                    //         }
                    //         let style = 'bold';
                    //         let result = null;
                    //         if (today) style = 'today';
                    //         if (this.state.periodType === 'day')
                    //             result = `{yy}\n{${style}|{MM}}\n{${style}|{dd}}\n{${style}|{ee}}`;
                    //         else if (this.state.periodType === 'month')
                    //             result = `{yyyy}\n{${style}|{MM}}`;
                    //         else
                    //             result = `{yyyy}`;
                    //         return result;
                    //     },
                    //     rich: {
                    //         bold: {
                    //             fontWeight: 700
                    //         },
                    //         today: {
                    //             color: '#aa5555',
                    //             fontWeight: 700
                    //         }
                    //     }
                    // }

                }
            ],
            yAxis: [
                {
                    type: 'value',
                    name: '預訂單數',
                    min: 0,
                    axisLabel: {
                        formatter: '{value}'
                    }
                },
            ],
            series: [
                {
                    name: '預訂單數',
                    type: 'bar',
                    tooltip: {
                        valueFormatter: function (value) {
                            return Number(value).toLocaleString() + ' 筆';
                        }
                    },
                    encode: { x: 'order_offset_day', y: 'count' },
                },
                {
                    name: '取消單數',
                    type: 'bar',
                    tooltip: {
                        valueFormatter: function (value) {
                            return Number(value).toLocaleString() + ' 筆';
                        }
                    },
                    encode: { x: 'order_offset_day', y: 'cancel_count' },
                },
            ]
        }
        this.setState({
            orderDateAnalysisChartOption: option,
            orderDateAnalysisAvg: (totalDaysBefore / totalSales).toFixed(2),
            orderDateAnalysisTotal: totalSales
        });
    }
    handleSelectDateType = (dateType) => {
        console.log("handleSelectDateType", dateType);
        this.setState({ dateType: dateType }, () => this.refresh());
    }
    handleSelectPeriodType = (value) => {
        console.log("handleSelectPeriodType", value);
        this.setState({ periodType: value }, () => this.refresh());
    }
    handleSelectRoomCode = (roomCod) => {
        console.log("handleSelectRoomCode", roomCod);
        this.setState({ selectedRoomCod: roomCod }, () => this.refresh());
    }
    handleSelectFilter = (e) => {
        console.log(e.target.value);
        this.setState({ filterType: e.target.value });
    }
    getDetails = () => {
        let items = this.state.details.filter((item) => {
            switch (this.state.filterType) {
                case 'not-canceled':
                    return item.cancel_dat === null;
                case 'canceled':
                    return item.cancel_dat !== null;
                case 'all':
                default:
                    return true;
            }
        });
        if (this.state.showOnlyBelowPrice) {
            items = items.filter((item) => item.total < 3200 * 0.7);
        }
        return items;
    }
    toggleShowOnlyBelowPrice = (e) => {
        this.setState({ showOnlyBelowPrice: e.target.checked });
    }
    showOrderDateStatDrawer = () => {
        this.setState({ orderDateStatDrawerVisible: true }, () => {
            this.updateOrderDateAnalysisChartOption();
        });
    }
    hideOrderDataStatDrawer = () => {
        this.setState({ orderDateStatDrawerVisible: false });
    }
    showOrderSourceStatDrawer = () => {
        const groupByCustName = this.getDetails().reduce((pv, cv, index) => {
            const found = pv.find((row) => row.ccust_cod === cv.ccust_cod);
            const quantity = cv.order_qnt * cv.days;
            const total = cv.rent_amt * quantity;
            if (found) {
                found.total += total;
                found.quantity += quantity;
                found.average = found.total / found.quantity;
                if (cv.rent_amt > 0) { // 略過異常數字
                    found.min = Math.min(found.min, cv.rent_amt);
                }
                found.max = Math.max(found.max, cv.rent_amt);
                found.count++;
            } else {
                pv.push({
                    ccust_cod: cv.ccust_cod,
                    cust_nam: cv.cust_nam,
                    total: total,
                    quantity: quantity,
                    average: total / quantity,
                    min: cv.rent_amt,
                    max: cv.rent_amt,
                    count: 0,
                });
            }
            return pv;
        }, []);

        const totalAmount = groupByCustName.reduce((pv, cv, index) => pv + cv.total, 0);
        groupByCustName.forEach((row) => {
            row.proportion = row.total / totalAmount;
        });
        console.log("details", groupByCustName);
        this.setState({
            orderSourceStatDrawer: {
                open: true,
                details: groupByCustName,
            }
        });
    }
    hideOrderSourceStatDrawer = () => {
        this.setState({
            orderSourceStatDrawer: {
                open: false,
                details: [],
            }
        });
    }
    render() {
        const columns = [
            {
                title: '訂單卡號',
                dataIndex: 'ikey',
                key: 'ikey',
                // onCell: (record, rowIndex) => {
                //     const items = this.getDetails().filter((item) => item.ikey === record.ikey);
                //     const count = items.length;
                //     if (count <= 1) return {};
                //     const isFirst = record.ikey_seq_nos === items[0].ikey_seq_nos;
                //     return {
                //         rowSpan: isFirst ? count : 0
                //     };
                // }
                sorter: (a, b) => `${a.ikey}-${a.ikey_seq_nos}`?.localeCompare(`${b.ikey}-${b.ikey_seq_nos}`),
            },
            {
                title: '項次',
                dataIndex: 'ikey_seq_nos',
                key: 'ikey_seq_nos',
                sorter: (a, b) => `${a.ikey}-${a.ikey_seq_nos}`?.localeCompare(`${b.ikey}-${b.ikey_seq_nos}`),
            },
            {
                title: '訂單日期',
                dataIndex: 'ins_dat',
                key: 'ins_dat',
                sorter: (a, b) => new Date(a.ins_dat).getTime() - new Date(b.ins_dat).getTime(),
            },
            {
                title: '提前預訂天數',
                dataIndex: 'order_offset_day',
                key: 'order_offset_day',
                sorter: (a, b) => a.order_offset_day - b.order_offset_day,
            },
            {
                title: '取消日期',
                dataIndex: 'cancel_dat',
                key: 'cancel_dat',
                render: (value) => value ? moment(value).format("YYYY-MM-DD") : '-',
                sorter: (a, b) => new Date(a.cancel_dat).getTime() - new Date(b.cancel_dat).getTime(),
            },
            {
                title: '訂房來源',
                dataIndex: 'cust_nam',
                key: 'cust_nam',
                sorter: (a, b) => a?.cust_nam?.localeCompare(b?.cust_nam),
            },
            {
                title: '團號',
                dataIndex: 'atten_nam',
                key: 'atten_nam',
                sorter: (a, b) => a?.atten_nam?.localeCompare(b?.atten_nam),
            },
            {
                title: '入住日期',
                dataIndex: 'ci_dat',
                key: 'ci_dat',
                render: (value) => moment(value).format("YYYY-MM-DD"),
                sorter: (a, b) => new Date(a.ci_dat).getTime() - new Date(b.ci_dat).getTime(),
            },
            {
                title: '退房日期',
                dataIndex: 'co_dat',
                key: 'co_dat',
                render: (value) => moment(value).format("YYYY-MM-DD"),
                sorter: (a, b) => new Date(a.co_dat).getTime() - new Date(b.co_dat).getTime(),
            },
            {
                title: '房價代碼',
                dataIndex: 'rate_cod',
                key: 'rate_cod',
                sorter: (a, b) => a.rate_cod?.localeCompare(b.rate_cod),
            },
            {
                title: '使用房種',
                dataIndex: 'room_cod',
                key: 'room_cod',
                sorter: (a, b) => a.room_cod?.localeCompare(b.room_cod),
                filters: this.state.roomCodFilters,
                onFilter: (value, record) => record.room_cod === value,
                filterSearch: true,
            },
            {
                title: '計價房種',
                dataIndex: 'use_cod',
                key: 'use_cod',
                sorter: (a, b) => a.use_cod?.localeCompare(b.use_cod),
                filters: this.state.useCodFilters,
                onFilter: (value, record) => record.use_cod === value,
                filterSearch: true,
            },
            {
                title: '房價 (含餐)',
                dataIndex: 'rent_amt',
                key: 'rent_amt',
                align: 'right',
                render: (value) => Number(value).toLocaleString(),
                sorter: (a, b) => a.rent_amt - b.rent_amt,
            },
            {
                title: '間數',
                dataIndex: 'order_qnt',
                key: 'order_qnt',
                sorter: (a, b) => a.order_qnt - b.order_qnt,
            },
            {
                title: '入住天數',
                dataIndex: 'days',
                key: 'days',
                sorter: (a, b) => a.days - b.days,
            },
            {
                title: '房價小計',
                dataIndex: 'total',
                key: 'total',
                align: 'right',
                fixed: 'right',
                render: (value) => {
                    if (value < 3200 * 0.7) {
                        return <span style={{ color: 'red ' }}>{Number(value).toLocaleString()}</span>
                    }
                    return Number(value).toLocaleString()
                },
                sorter: (a, b) => a.total - b.total,
            },
            // RENT_TOT 在有 "多筆明細" (IKEY_SEQ_NOS) 時數值會是整筆訂單的總額，因此若做為明細的含餐總計會重覆計算，因此不可直接用 RENT_TOT 做統計
            // {
            //     title: '總計 (含餐)',
            //     dataIndex: 'rent_tot',
            //     key: 'rent_tot',
            //     align: 'right',
            // },
            // {
            //     title: '折扣率',
            //     dataIndex: 'rent_tot',
            //     key: 'rent_tot',
            //     render: (value, record) => (record.rent_tot/record.total).toFixed(2)
            // }
        ];
        
        // 獲取總覽表格欄位定義
        const overviewColumns = [
            {
                title: '日期',
                dataIndex: 'dat',
                key: 'dat',
                sorter: (a, b) => new Date(a.dat).getTime() - new Date(b.dat).getTime(),
                render: (date) => <DateWithWeekday date={date} />,
            },
            {
                title: '銷售總額',
                dataIndex: 'sale_tot',
                key: 'sale_tot',
                align: 'right',
                render: (value) => 'NT$ ' + Number(value).toLocaleString(),
                sorter: (a, b) => a.sale_tot - b.sale_tot,
            },
            {
                title: '取消總額',
                dataIndex: 'cancel_tot',
                key: 'cancel_tot',
                align: 'right',
                render: (value) => 'NT$ ' + Number(value).toLocaleString(),
                sorter: (a, b) => a.cancel_tot - b.cancel_tot,
            },
            {
                title: '銷售數量',
                dataIndex: 'sale_qty',
                key: 'sale_qty',
                align: 'right',
                sorter: (a, b) => a.sale_qty - b.sale_qty,
            },
            {
                title: '取消數量',
                dataIndex: 'cancel_qty',
                key: 'cancel_qty',
                align: 'right',
                sorter: (a, b) => a.cancel_qty - b.cancel_qty,
            },
            {
                title: '銷售平均',
                dataIndex: 'sale_avg',
                key: 'sale_avg',
                align: 'right',
                render: (value, record) => {
                    const avg = record.sale_qty > 0 ? Math.round(record.sale_tot / record.sale_qty) : 0;
                    return 'NT$ ' + Number(avg).toLocaleString();
                },
                sorter: (a, b) => {
                    const aAvg = a.sale_qty > 0 ? a.sale_tot / a.sale_qty : 0;
                    const bAvg = b.sale_qty > 0 ? b.sale_tot / b.sale_qty : 0;
                    return aAvg - bAvg;
                },
            },
            {
                title: '取消平均',
                dataIndex: 'cancel_avg',
                key: 'cancel_avg',
                align: 'right',
                render: (value, record) => {
                    const avg = record.cancel_qty > 0 ? Math.round(record.cancel_tot / record.cancel_qty) : 0;
                    return 'NT$ ' + Number(avg).toLocaleString();
                },
                sorter: (a, b) => {
                    const aAvg = a.cancel_qty > 0 ? a.cancel_tot / a.cancel_qty : 0;
                    const bAvg = b.cancel_qty > 0 ? b.cancel_tot / b.cancel_qty : 0;
                    return aAvg - bAvg;
                },
            },
            {
                title: '操作',
                key: 'action',
                align: 'center',
                fixed: 'right',
                render: (value, record) => (
                    <Typography.Link
                        onClick={() => {
                            this.fetchDetail(record.dat);
                            this.setState({ activeTabKey: '2', detailDate: record.dat });
                        }}
                    >
                        明細
                    </Typography.Link>
                ),
            },
        ];
        
        return (
            <Spin spinning={this.state.loading}>
                <h1>銷售統計</h1>
                <Form>
                    <Row gutter={5} justify="end">
                        <Col xs={12} sm={12} lg={4}>
                            <Form.Item label="類型">
                                <Select value={this.state.dateType} onChange={this.handleSelectDateType}>
                                    <Select.Option key="insdate">新增日期</Select.Option>
                                    <Select.Option key="cidate">入住日期</Select.Option>
                                </Select>
                            </Form.Item>
                        </Col>
                        <Col xs={12} sm={12} lg={4}>
                            <Form.Item label="週期">
                                <Select value={this.state.periodType} onChange={this.handleSelectPeriodType}>
                                    <Select.Option key="year">年</Select.Option>
                                    <Select.Option key="month">月</Select.Option>
                                    <Select.Option key="day">日</Select.Option>
                                </Select>
                            </Form.Item>
                        </Col>
                        <Col xs={12} sm={12} lg={4}>
                            <Form.Item label="房型">
                                <PmsRoomSelect
                                    value={this.state.selectedRoomCod}
                                    onChange={this.handleSelectRoomCode}
                                />
                            </Form.Item>
                        </Col>
                    </Row>
                </Form>
                <ResponsiveECharts option={this.state.salesChartOption} onEvents={{
                    'click': this.handleClickChartEvent
                }} />
                <Tabs
                    activeKey={this.state.activeTabKey}
                    onChange={(key) => this.setState({ activeTabKey: key })}
                >
                    <Tabs.TabPane key="1" tab="總覽">
                        <Table
                            columns={overviewColumns}
                            dataSource={this.state.overviewData}
                            scroll={{ x: 'max-content' }}
                            loading={this.state.loading}
                            size="small"
                        />
                    </Tabs.TabPane>
                    <Tabs.TabPane key="2" tab="明細">
                        <Row style={{ marginBottom: 10 }}>
                            <Col span={18}>查詢日期: {this.state.detailDate ? this.state.detailDate : '無'}</Col>
                        </Row>
                        <Row style={{ marginBottom: 10 }} gutter={[10, 10]}>
                            <Col xs={24} sm={24} lg={12}>
                                <Form layout="inline">
                                    <Form.Item label="當日間數小計">{this.getDetails().reduce((pv, cv, idx, arr) => pv + parseInt(cv.order_qnt), 0)}</Form.Item>
                                    <Form.Item label="當日房價小計">${this.getDetails().reduce((pv, cv, idx, arr) => pv + cv.order_qnt * cv.rent_amt, 0)}</Form.Item>
                                    <Form.Item label="間數小計">{this.getDetails().reduce((pv, cv, idx, arr) => pv + parseInt(cv.order_qnt * cv.days), 0)}</Form.Item>
                                    <Form.Item label="房價總計">${this.getDetails().reduce((pv, cv, idx, arr) => pv + cv.total, 0)}</Form.Item>
                                    <Form.Item label="房價平均">${(this.getDetails().reduce((pv, cv, idx, arr) => pv + parseInt(cv.total), 0) / this.getDetails().reduce((pv, cv, idx, arr) => pv + parseInt(cv.order_qnt * cv.days), 0)).toFixed(2)}</Form.Item>
                                    {/* <Form.Item label="明細總計">${this.getDetails().reduce((pv, cv, idx, arr) => pv + parseInt(cv.rent_tot), 0)}</Form.Item> */}
                                    {/* <Form.Item label="含餐平均">${(this.getDetails().reduce((pv, cv, idx, arr) => pv + parseInt(cv.rent_tot), 0) / this.getDetails().reduce((pv, cv, idx, arr) => pv + parseInt(cv.order_qnt * cv.days), 0)).toFixed(2)}</Form.Item> */}
                                </Form>
                            </Col>
                            <Col xs={24} sm={24} lg={12} style={{ textAlign: 'right' }}>
                                <Space>
                                    <Checkbox checked={this.state.showOnlyBelowPrice} onChange={this.toggleShowOnlyBelowPrice}>只顯示低於牌價 7 折的銷售</Checkbox>
                                    <Radio.Group
                                        optionType="button"
                                        buttonStyle="solid"
                                        value={this.state.filterType}
                                        onChange={this.handleSelectFilter}
                                        options={[
                                            { label: '未取消', value: 'not-canceled' },
                                            { label: '已取消', value: 'canceled' },
                                            { label: '全部', value: 'all' },
                                        ]} />
                                </Space>
                            </Col>
                            <Col span={24} style={{ textAlign: 'right' }}>
                                <Space>
                                    <Button onClick={this.showOrderDateStatDrawer}>預訂天數分析</Button>
                                    <Button onClick={this.showOrderSourceStatDrawer}>來源價格分析</Button>
                                </Space>
                            </Col>
                        </Row>
                        <Table ref={this.table} columns={columns} dataSource={this.getDetails()} scroll={{ x: 'max-content' }} loading={this.state.detailLoading} rowKey="id" size="small" />
                    </Tabs.TabPane>
                </Tabs>
                <Drawer visible={this.state.orderDateStatDrawerVisible} onClose={this.hideOrderDataStatDrawer} title="訂單提前預訂天數分析" width={1000}>
                    <Descriptions title="分析資訊">
                        <Descriptions.Item label="查詢日期">
                            {this.state.detailDate ? this.state.detailDate : '無'}
                        </Descriptions.Item>
                        <Descriptions.Item label="提前預訂平均">
                            {this.state.orderDateAnalysisAvg} 天
                        </Descriptions.Item>
                        <Descriptions.Item label="訂單總計">
                            {this.state.orderDateAnalysisTotal} 筆
                        </Descriptions.Item>
                    </Descriptions>
                    <ResponsiveECharts option={this.state.orderDateAnalysisChartOption} />
                    <ul>
                        <li>住客若預期該期間住房率會較高則會越早提前預訂</li>
                        <li>未來日期因未到達，所以無法看到正確的提前預定天數</li>
                        <li>可考慮擬定部份不可退訂的銷售優惠給超過平均提前預定天數的訂單</li>
                    </ul>
                </Drawer>
                <Drawer visible={this.state.orderSourceStatDrawer.open} onClose={this.hideOrderSourceStatDrawer} title="來源價格分析" width={1200}>
                    <Table columns={[
                        {
                            dataIndex: 'ccust_cod',
                            title: 'ID',
                            render: (value) => value ?? '無',
                        },
                        {
                            dataIndex: 'cust_nam',
                            title: '訂房來源 (旅行社)',
                            render: (value) => value ?? '無',
                        },
                        {
                            dataIndex: 'quantity',
                            title: '間數',
                            sorter: (a, b) => a.quantity - b.quantity,
                            align: 'right',
                        },
                        {
                            dataIndex: 'total',
                            title: '小計',
                            sorter: (a, b) => a.total - b.total,
                            render: (value) => value.toLocaleString(),
                            align: 'right',
                            defaultSortOrder: 'descend',
                        },
                        {
                            title: '佔比',
                            dataIndex: 'proportion',
                            sorter: (a, b) => a.proportion - b.proportion,
                            render: (value) => (value * 100).toFixed(2),
                            align: 'right',
                        },
                        {
                            dataIndex: 'min',
                            title: '最低房價 (含餐)',
                            sorter: (a, b) => a.min - b.min,
                            render: (value) => value.toFixed(0).toLocaleString(),
                            align: 'right',
                        },
                        {
                            dataIndex: 'average',
                            title: '平均房價 (含餐)',
                            sorter: (a, b) => a.average - b.average,
                            render: (value) => value.toFixed(0).toLocaleString(),
                            align: 'right',
                            defaultSortOrder: 'ascend',
                        },
                        {
                            dataIndex: 'max',
                            title: '最高房價 (含餐)',
                            sorter: (a, b) => a.max - b.max,
                            render: (value) => value.toFixed(0).toLocaleString(),
                            align: 'right',
                        },
                        {
                            dataIndex: 'min',
                            title: '平日價比',
                            render: (value) => (value / 3600).toFixed(2),
                            align: 'right',
                        },
                    ]}
                        dataSource={this.state.orderSourceStatDrawer.details}
                        rowKey="ccust_cod"
                        pagination={false}
                        size="small"
                        scroll={{ x: 'max-content' }}
                        summary={(records) => {
                            const totalAmount = records.reduce((pv, cv, index) => pv + cv.total, 0);
                            const totalQty = records.reduce((pv, cv, index) => pv + cv.quantity, 0);
                            const totalCount = records.reduce((pv, cv, index) => pv + cv.count, 0);
                            return (
                                <Table.Summary fixed>
                                    <Table.Summary.Row>
                                        <Table.Summary.Cell index={0}>
                                            <span style={{ fontWeight: 'bold' }}>總計</span>
                                        </Table.Summary.Cell>
                                        <Table.Summary.Cell align="right" index={1}>
                                            <span style={{ fontWeight: 'bold' }}>{totalCount}</span>
                                        </Table.Summary.Cell>
                                        <Table.Summary.Cell align="right" index={2}>
                                            <span style={{ fontWeight: 'bold' }}>{totalQty}</span>
                                        </Table.Summary.Cell>
                                        <Table.Summary.Cell align="right" index={3}>
                                            <span style={{ fontWeight: 'bold' }}>{totalAmount.toLocaleString()}</span>
                                        </Table.Summary.Cell>
                                        <Table.Summary.Cell index={4}></Table.Summary.Cell>
                                    </Table.Summary.Row>
                                </Table.Summary>
                            )
                        }}
                    />
                </Drawer>
            </Spin>
        )
    }
}

export default SalesPage